import React, { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";
import { Logo } from "./Logo";

const links = [
  { label: "Home", href: "/#home" },
  { label: "Calculator", href: "/#calculator" },
  { label: "Services", href: "/#services" },
  { label: "Contact", href: "#contact" }, // footer — present on every page
];

export const Navbar = () => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    document.body.style.overflow = open ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [open]);

  return (
    <nav
      className="fixed top-0 left-0 right-0 z-50"
      style={{
        height: 64,
        backgroundColor: "#0D1117",
        borderBottom: "1px solid rgba(255,255,255,0.08)",
      }}
      data-testid="main-navbar"
    >
      <div className="max-w-7xl mx-auto h-full px-5 sm:px-8 flex items-center justify-between">
        <a href="/#home" className="shrink-0" data-testid="nav-logo-link">
          <Logo />
        </a>

        {/* Desktop links */}
        <div className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <a
              key={l.label}
              href={l.href}
              className="relative flex items-center gap-2 text-white text-sm transition-colors duration-150 hover:text-[#1D9E75]"
              data-testid={`nav-link-${l.label.toLowerCase()}`}
            >
              {l.label}
              {l.badge && (
                <span
                  className="rounded-full px-2 py-0.5 text-[10px] font-medium"
                  style={{ backgroundColor: "#FAEEDA", color: "#854F0B" }}
                >
                  Coming Soon
                </span>
              )}
            </a>
          ))}
        </div>

        {/* Mobile toggle */}
        <button
          className="md:hidden text-white p-2 -mr-2"
          onClick={() => setOpen((o) => !o)}
          aria-label="Toggle menu"
          data-testid="nav-mobile-toggle"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {/* Mobile dropdown */}
      {open && (
        <div
          className="md:hidden absolute left-0 right-0 top-16"
          style={{
            backgroundColor: "#0D1117",
            borderBottom: "1px solid rgba(255,255,255,0.08)",
          }}
          data-testid="nav-mobile-menu"
        >
          <div className="flex flex-col px-5 py-4 gap-1">
            {links.map((l) => (
              <a
                key={l.label}
                href={l.href}
                onClick={() => setOpen(false)}
                className="flex items-center gap-2 text-white text-sm py-3 px-2 rounded-md hover:bg-white/5 transition-colors"
                data-testid={`nav-mobile-link-${l.label.toLowerCase()}`}
              >
                {l.label}
                {l.badge && (
                  <span
                    className="rounded-full px-2 py-0.5 text-[10px] font-medium"
                    style={{ backgroundColor: "#FAEEDA", color: "#854F0B" }}
                  >
                    Coming Soon
                  </span>
                )}
              </a>
            ))}
          </div>
        </div>
      )}
    </nav>
  );
};
